export default __webpack_public_path__ + "static/media/Boots of Bestial Rage.5da9b5b9.jpg";